import categories from '../../assets/freelancers/categories.svg';
import matching from '../../assets/freelancers/matching.svg';
import quickly from '../../assets/freelancers/quickly.svg';
import happy from '../../assets/freelancers/happy.svg';

const freelancersData = [
    {
        id: 'categories',
        title: 'logged_out_homepage.freelancers.categories',
        image: categories,
    },
    {
        id: 'matching',
        title: 'logged_out_homepage.freelancers.matching',
        image: matching,
    },
    {
        id: 'quickly',
        title: 'logged_out_homepage.freelancers.quickly',
        image: quickly,
    },
    {
        id: 'happy',
        title: 'logged_out_homepage.freelancers.happy',
        image: happy,
    },
];

export default freelancersData;
